export default {
    init() {
        setupCursorGlow();
    }
}

function setupCursorGlow() {
    cursorGlow();
}

function cursorGlow() {
    let mouseX = 0, mouseY = 0;
    let xPos = 0, yPos = 0;

    $(document).mousemove(function(e){
        mouseX = e.clientX - 0;
        mouseY = e.clientY - 0;
        $('.cursor-element').addClass('xl:block');
    });

    setInterval(function(){
        xPos += ((mouseX - xPos)/10);
        yPos += ((mouseY - yPos)/10);
        $('.cursor-element').css({left: xPos + 'px', top: yPos + 'px'});
    }, 8);
}
